export default {
    user_00001: "nombre de usuario/teléfono/licencia",
    user_00002: "User",
    user_00003: "seguimiento",
    user_00004: "Unfollwed",
    user_00005: "Export user",
    user_00006: "Esto descargará el usuario del archivo Excel, ¿continuar?",
}